import {
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
  atomic$long$129k9zwo6n9ogd as atomic$long$1,
} from '../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  shiftRight2gqph14wydb8s as shiftRight,
  convertToInty04h231mmjoh as convertToInt,
  fromInt2ii0rejb1w62w as fromInt,
  shiftLeft3tsh2sstjchzn as shiftLeft,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Symbol17xuwzgi5g8ve as Symbol } from './Symbol.mjs';
import { atomicfu$AtomicRefArray$ofNulls2kz3j9ehigwa3 as atomicfu$AtomicRefArray$ofNulls } from '../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.common.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var LockFreeTaskQueueClass;
function LockFreeTaskQueue() {
  if (LockFreeTaskQueueClass === VOID) {
    class $ {
      constructor(singleConsumer) {
        this.c1j_1 = atomic$ref$1(new (LockFreeTaskQueueCore())(8, singleConsumer));
      }
      q2() {
        return this.c1j_1.kotlinx$atomicfu$value.q2();
      }
      f1j(element) {
        // Inline function 'kotlinx.atomicfu.loop' call
        var this_0 = this.c1j_1;
        while (true) {
          var cur = this_0.kotlinx$atomicfu$value;
          switch (cur.f1j(element)) {
            case 0:
              return true;
            case 2:
              return false;
            case 1:
              this.c1j_1.atomicfu$compareAndSet(cur, cur.r1());
              break;
          }
        }
      }
      uj() {
        // Inline function 'kotlinx.atomicfu.loop' call
        var this_0 = this.c1j_1;
        while (true) {
          var cur = this_0.kotlinx$atomicfu$value;
          var result = cur.uj();
          if (!(result === Companion_getInstance().y1j_1))
            return result;
          this.c1j_1.atomicfu$compareAndSet(cur, cur.r1());
        }
      }
    }
    initMetadataForClass($, 'LockFreeTaskQueue');
    LockFreeTaskQueueClass = $;
  }
  return LockFreeTaskQueueClass;
}
function fillPlaceholder($this, index, element) {
  var old = $this.l1j_1.atomicfu$get(index & $this.i1j_1).kotlinx$atomicfu$value;
  var tmp;
  if (old instanceof Placeholder()) {
    tmp = old.c1k_1 === index;
  } else {
    tmp = false;
  }
  if (tmp) {
    $this.l1j_1.atomicfu$get(index & $this.i1j_1).kotlinx$atomicfu$value = element;
    return $this;
  }
  return null;
}
function removeSlowPath($this, oldHead, newHead) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.k1j_1;
  while (true) {
    var state = this_0.kotlinx$atomicfu$value;
    // Inline function 'kotlinx.coroutines.internal.Companion.withState' call
    Companion_getInstance();
    var head = convertToInt(shiftRight(state & 1073741823n, 0));
    var tail = convertToInt(shiftRight(state & 1152921503533105152n, 30));
    // Inline function 'kotlinx.coroutines.assert' call
    if (!((state & 1152921504606846976n) === 0n)) {
      return $this.r1();
    }
    if ($this.k1j_1.atomicfu$compareAndSet(state, Companion_getInstance().d1k(state, newHead))) {
      $this.l1j_1.atomicfu$get(head & $this.i1j_1).kotlinx$atomicfu$value = null;
      return null;
    }
  }
}
function markFrozen($this) {
  var tmp0 = $this.k1j_1;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.updateAndGet' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      if (!((cur & 1152921504606846976n) === 0n))
        return cur;
      var upd = cur | 1152921504606846976n;
      if (tmp0.atomicfu$compareAndSet(cur, upd)) {
        tmp$ret$0 = upd;
        break $l$block;
      }
    }
  }
  return tmp$ret$0;
}
function allocateOrGetNextCopy($this, state) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.j1j_1;
  while (true) {
    var next = this_0.kotlinx$atomicfu$value;
    if (!(next == null))
      return next;
    $this.j1j_1.atomicfu$compareAndSet(null, allocateNextCopy($this, state));
  }
}
function allocateNextCopy($this, state) {
  var next = new (LockFreeTaskQueueCore())(imul($this.g1j_1, 2), $this.h1j_1);
  // Inline function 'kotlinx.coroutines.internal.Companion.withState' call
  Companion_getInstance();
  var head = convertToInt(shiftRight(state & 1073741823n, 0));
  var tail = convertToInt(shiftRight(state & 1152921503533105152n, 30));
  var index = head;
  while (!((index & $this.i1j_1) === (tail & $this.i1j_1))) {
    var tmp0_elvis_lhs = $this.l1j_1.atomicfu$get(index & $this.i1j_1).kotlinx$atomicfu$value;
    var value = tmp0_elvis_lhs == null ? new (Placeholder())(index) : tmp0_elvis_lhs;
    next.l1j_1.atomicfu$get(index & next.i1j_1).kotlinx$atomicfu$value = value;
    index = index + 1 | 0;
  }
  next.k1j_1.kotlinx$atomicfu$value = Companion_getInstance().e1k(state, 1152921504606846976n);
  return next;
}
var PlaceholderClass;
function Placeholder() {
  if (PlaceholderClass === VOID) {
    class $ {
      constructor(index) {
        this.c1k_1 = index;
      }
    }
    initMetadataForClass($, 'Placeholder');
    PlaceholderClass = $;
  }
  return PlaceholderClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.m1j_1 = 8;
        this.n1j_1 = 30;
        this.o1j_1 = 1073741823;
        this.p1j_1 = 0;
        this.q1j_1 = 1073741823n;
        this.r1j_1 = 30;
        this.s1j_1 = 1152921503533105152n;
        this.t1j_1 = 60;
        this.u1j_1 = 1152921504606846976n;
        this.v1j_1 = 61;
        this.w1j_1 = 2305843009213693952n;
        this.x1j_1 = 1024;
        this.y1j_1 = new (Symbol())('REMOVE_FROZEN');
        this.z1j_1 = 0;
        this.a1k_1 = 1;
        this.b1k_1 = 2;
      }
      e1k(_this__u8e3s4, other) {
        return _this__u8e3s4 & ~other;
      }
      d1k(_this__u8e3s4, newHead) {
        return this.e1k(_this__u8e3s4, 1073741823n) | shiftLeft(fromInt(newHead), 0);
      }
      f1k(_this__u8e3s4, newTail) {
        return this.e1k(_this__u8e3s4, 1152921503533105152n) | shiftLeft(fromInt(newTail), 30);
      }
      g1k(_this__u8e3s4) {
        return !((_this__u8e3s4 & 2305843009213693952n) === 0n) ? 2 : 1;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var LockFreeTaskQueueCoreClass;
function LockFreeTaskQueueCore() {
  if (LockFreeTaskQueueCoreClass === VOID) {
    class $ {
      constructor(capacity, singleConsumer) {
        Companion_getInstance();
        this.g1j_1 = capacity;
        this.h1j_1 = singleConsumer;
        this.i1j_1 = this.g1j_1 - 1 | 0;
        this.j1j_1 = atomic$ref$1(null);
        this.k1j_1 = atomic$long$1(0n);
        this.l1j_1 = atomicfu$AtomicRefArray$ofNulls(this.g1j_1);
        // Inline function 'kotlin.check' call
        if (!(this.i1j_1 <= 1073741823)) {
          throw IllegalStateException().o('Check failed.');
        }
        // Inline function 'kotlin.check' call
        if (!((this.g1j_1 & this.i1j_1) === 0)) {
          throw IllegalStateException().o('Check failed.');
        }
      }
      q2() {
        Companion_getInstance();
        // Inline function 'kotlinx.coroutines.internal.Companion.withState' call
        var this_0 = this.k1j_1.kotlinx$atomicfu$value;
        var head = convertToInt(shiftRight(this_0 & 1073741823n, 0));
        var tail = convertToInt(shiftRight(this_0 & 1152921503533105152n, 30));
        return (tail - head | 0) & 1073741823;
      }
      f1j(element) {
        // Inline function 'kotlinx.atomicfu.loop' call
        var this_0 = this.k1j_1;
        while (true) {
          var tmp0 = this_0.kotlinx$atomicfu$value;
          $l$block: {
            if (!((tmp0 & 3458764513820540928n) === 0n))
              return Companion_getInstance().g1k(tmp0);
            // Inline function 'kotlinx.coroutines.internal.Companion.withState' call
            Companion_getInstance();
            var head = convertToInt(shiftRight(tmp0 & 1073741823n, 0));
            var tail = convertToInt(shiftRight(tmp0 & 1152921503533105152n, 30));
            var mask = this.i1j_1;
            if (((tail + 2 | 0) & mask) === (head & mask))
              return 1;
            if (!this.h1j_1 && !(this.l1j_1.atomicfu$get(tail & mask).kotlinx$atomicfu$value == null)) {
              if (this.g1j_1 < 1024 || ((tail - head | 0) & 1073741823) > this.g1j_1 >> 1) {
                return 1;
              }
              break $l$block;
            }
            var newTail = (tail + 1 | 0) & 1073741823;
            if (this.k1j_1.atomicfu$compareAndSet(tmp0, Companion_getInstance().f1k(tmp0, newTail))) {
              this.l1j_1.atomicfu$get(tail & mask).kotlinx$atomicfu$value = element;
              var cur = this;
              $l$loop_0: while ((cur.k1j_1.kotlinx$atomicfu$value & 1152921504606846976n) !== 0n) {
                var tmp0_elvis_lhs = fillPlaceholder(cur.r1(), tail, element);
                var tmp;
                if (tmp0_elvis_lhs == null) {
                  break $l$loop_0;
                } else {
                  tmp = tmp0_elvis_lhs;
                }
                cur = tmp;
              }
              return 0;
            }
          }
        }
      }
      uj() {
        // Inline function 'kotlinx.atomicfu.loop' call
        var this_0 = this.k1j_1;
        while (true) {
          var tmp0 = this_0.kotlinx$atomicfu$value;
          $l$block_0: {
            if (!((tmp0 & 1152921504606846976n) === 0n))
              return Companion_getInstance().y1j_1;
            // Inline function 'kotlinx.coroutines.internal.Companion.withState' call
            Companion_getInstance();
            var head = convertToInt(shiftRight(tmp0 & 1073741823n, 0));
            var tail = convertToInt(shiftRight(tmp0 & 1152921503533105152n, 30));
            if ((tail & this.i1j_1) === (head & this.i1j_1))
              return null;
            var element = this.l1j_1.atomicfu$get(head & this.i1j_1).kotlinx$atomicfu$value;
            if (element == null) {
              if (this.h1j_1)
                return null;
              break $l$block_0;
            }
            if (element instanceof Placeholder())
              return null;
            var newHead = (head + 1 | 0) & 1073741823;
            if (this.k1j_1.atomicfu$compareAndSet(tmp0, Companion_getInstance().d1k(tmp0, newHead))) {
              this.l1j_1.atomicfu$get(head & this.i1j_1).kotlinx$atomicfu$value = null;
              return element;
            }
            if (!this.h1j_1) {
              break $l$block_0;
            }
            var cur = this;
            while (true) {
              var tmp0_elvis_lhs = removeSlowPath(cur, head, newHead);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                return element;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              cur = tmp;
            }
          }
        }
      }
      r1() {
        return allocateOrGetNextCopy(this, markFrozen(this));
      }
    }
    initMetadataForClass($, 'LockFreeTaskQueueCore');
    LockFreeTaskQueueCoreClass = $;
  }
  return LockFreeTaskQueueCoreClass;
}
//region block: exports
export {
  LockFreeTaskQueue as LockFreeTaskQueue36fqk9kdm4om8,
};
//endregion

//# sourceMappingURL=LockFreeTaskQueue.mjs.map
